let searchTimeout;
let searchController = null;

let searchInput = null;
let resultsDiv = null;

document.addEventListener('DOMContentLoaded', function () {

  searchInput = document.getElementById('blog-search-input');
  resultsDiv = document.getElementById('blog-search-results');

  const searchToggle = document.querySelector('.blog-search-toggle');
  const searchForm = document.querySelector('.blog-search-form');
  const searchClose = document.querySelector('.blog-search-close');

  if (!searchInput || !resultsDiv) return;

  // Live Search
  searchInput.addEventListener('input', function () {
    searchBlog(this.value.trim());
  });

  // Enter key
  searchInput.addEventListener('keydown', function (e) {

    if (e.key === 'Enter') {

      e.preventDefault();

      const query = this.value.trim();

      if (query.length) {
        window.location.href =
          '/search?q=' +
          encodeURIComponent(query) +
          '&type=article&blog_search=true';
      }
    }

  });

  // Open Search
  if (searchToggle && searchForm) {

    searchToggle.addEventListener('click', function () {
      searchForm.classList.add('active');
      searchInput.focus();
    });

  }

  // Close Search
  if (searchClose && searchForm) {

    searchClose.addEventListener('click', function () {
      searchForm.classList.remove('active');
      closeSearchResults();
    });

  }

});

function searchBlog(query) {

  if (!resultsDiv) return;

  clearTimeout(searchTimeout);

  if (searchController) {
    searchController.abort();
  }

  if (query.length < 2) {
    resultsDiv.innerHTML = '';
    return;
  }

  searchTimeout = setTimeout(function () {

    searchController = new AbortController();

    fetch(
      '/search/suggest.json?q=' +
      encodeURIComponent(query) +
      '&resources[type]=article&resources[limit]=10',
      {
        signal: searchController.signal
      }
    )

    .then(function(response) {
      return response.json();
    })

    .then(function(data) {

      const articles =
        data.resources &&
        data.resources.results &&
        data.resources.results.articles
          ? data.resources.results.articles
          : [];

      if (!articles.length) {

        resultsDiv.innerHTML = `
          <div class="blog-search-results-wrapper">

            <button
              type="button"
              onclick="closeSearchResults()"
              class="blog-search-close-btn">
              ×
            </button>

            <div class="blog-search-no-results">
              No blog posts found.
            </div>

          </div>
        `;

        return;
      }

      let html = `
        <div class="blog-search-results-wrapper">

          <button
            type="button"
            onclick="closeSearchResults()"
            class="blog-search-close-btn">
            ×
          </button>

          <div class="search-result-inner-wrapper">
      `;

      articles.forEach(function(article) {

        const imageUrl = article.image || '';

        html += `

          <a href="${article.url}" class="blog-search-item">

            ${
              imageUrl
              ? `
                <img
                  src="${imageUrl}"
                  alt="${article.title}"
                  class="blog-search-image"
                  loading="lazy"
                  decoding="async"
                  width="80"
                  height="80">
              `
              : ''
            }

            <div class="blog-search-content">

              <div class="blog-search-title">
                ${article.title}
              </div>

              ${
                article.tags && article.tags.length
                ? `
                  <div class="blog-search-tags">
                    ${article.tags.join(', ')}
                  </div>
                `
                : ''
              }

            </div>

          </a>

        `;

      });

      html += `
          </div>
        </div>
      `;

      resultsDiv.innerHTML = html;

    })

    .catch(function(error) {

      if (error.name !== 'AbortError') {
        console.error('Search Error:', error);
      }

    });

  }, 300);

}

function closeSearchResults() {

  if (resultsDiv) {
    resultsDiv.innerHTML = '';
  }

  if (searchInput) {
    searchInput.value = '';
  }

}